import { useSetHighlightedIdsState } from './store/use-set-highlighted-ids-state.js';
import { useSetVisibleSlicesState } from './store/use-set-visible-slices-state.js';
import { LegendItem } from '../../core/components/legend/categorical/types/legend.js';
import { InternalSliceData } from '../types/internal/pie-chart.js';
import { getSlicesMap } from '../utils/get-slices-map.js';
import { getSlicesWithRelativeValues } from '../utils/plot-data.utils.js';

/**
 * Hook that generates the corresponding handlers to interact with the Pie
 * @param data - array of the pie slices
 * @returns Handlers to interact with the Pie slices
 */
export function usePieHandlers(data: InternalSliceData[]) {
  const setVisibleSlicesState = useSetVisibleSlicesState();
  const setHighlightedIdsState = useSetHighlightedIdsState();

  const slicesMap = getSlicesMap(data);

  const onLegendItemHover = (hoveredSeries?: LegendItem[]) => {
    const hoveredSeriesIds = hoveredSeries?.map((s) => s.id);
    setHighlightedIdsState(hoveredSeriesIds || []);
  };

  const onLegendItemClicked = (visibleSlices: LegendItem[]) => {
    const newVisibleSlices: InternalSliceData[] = visibleSlices.map(
      (legendItem) => ({
        ...(slicesMap.get(legendItem.id) as InternalSliceData),
      }),
    );

    setVisibleSlicesState(
      getSlicesWithRelativeValues(newVisibleSlices) as InternalSliceData[],
    );
  };

  return { onLegendItemHover, onLegendItemClicked };
}
